import React from 'react';
import PropTypes from 'prop-types';

import { 
  Button, 
  CircularProgress,
}                     from '@material-ui/core';

import { 
  createMuiTheme, 
  MuiThemeProvider,
}                           from '@material-ui/core/styles';

import MUIDataTable         from 'mui-datatables';

import {
  ResourceToolbar,
  ResourcePolyCard,
  ResourceDataTableCustomFooter,
}                           from "../components";

export default function ResourceDataTable(props) {
  
  const { title, data, columns, columnOrder, loading, onSelect, onChangePrefs } = props;
  const [layout, setLayout] = React.useState('list');
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('StackUpdated');

  const resources = data;
  
  const handleSelectLayout = (event, newLayout) => {
    setLayout(newLayout);
  };

  const muiTheme = createMuiTheme({
    overrides: {
      MuiTableHead: {
        root: {
          visibility: layout==='list'? "inherit": "collapse",
        },
      },
      MUIDataTableToolbar: {
        actions: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }
      },
      MUIDataTable: {
        root: {
          size: "small"
        },
        paper: {
          boxShadow: "none",
        },
      },
    }
  });

  const handleViewColumnsChange = (changedColumn, action) => {
    if(onChangePrefs) {
      onChangePrefs({
        type: 'VIEW_COLUMNS',
        changedColumn,
        action
      });
    }
  };

  const handleColumnOrderChange = (newColumnOrder, columnIndex, newPosition) => {
    if(onChangePrefs) {
      onChangePrefs({
        type: 'COLUMN_ORDER',
        newColumnOrder,
        columnIndex,
        newPosition
      });
    }
  };

  const handleColumnSortChange = (changedColumn, direction) => {
    setOrder(direction);
    setOrderBy(changedColumn);
  };

  const handleRowClick = (rowData, rowMeta) => {
    if(onSelect) {
      onSelect(data[rowMeta.dataIndex]);
    }
  };

  const options = {
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
      return (
        <ResourceDataTableCustomFooter
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          textLabels={textLabels}
          layout={layout}
        />
      );
    },
    customToolbar: () => {
      return (
        <ResourceToolbar layout={layout} onSelectLayout={handleSelectLayout}/>
      );
    },
    customRowRender: layout==='list' ? null : (data, dataIndex, rowIndex) => {
      const resource=resources[dataIndex];
      return(resource?<tr key="1"><td colSpan={data.length}><ResourcePolyCard resource={resource} /></td></tr>:null);
    },
    columnOrder: columnOrder,
    draggableColumns: { enabled: true },
    enableNestedDataAccess: ".",
    print: false,
    onColumnSortChange: handleColumnSortChange,
    onColumnOrderChange: handleColumnOrderChange,
    onViewColumnsChange: handleViewColumnsChange,
    //onRowClick: handleRowClick,
    resizableColumns: false,
    rowsPerPage: layout==='list' ? 50 : 1,
    search: true,
    selectableRows: "none",
    sortOrder: {
      name: orderBy,
      direction: order
    },
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    viewColumns: layout==='list',
    textLabels: {
      body: {
        noMatch: loading?"":"Sorry, no matching records found",
      },
    },
  };

  var displayTitle=null;
  
  if(loading) {
    displayTitle=<Button disabled size="small" style={{ width: '125px' }} startIcon={<CircularProgress size={20}/>}>Loading...</Button>;
  // } else if(more) {
  //   displayTitle=
  //   <Tooltip title="Load more rows from server...">
  //   <Button size="small" style={{ width: '125px' }} startIcon={<MoreIcon/>} onClick={onLoadMore}>Load More</Button>
  //   </Tooltip>;
  }

  if(React.isValidElement(title)) {
    displayTitle=<React.Fragment>{title}{displayTitle}</React.Fragment>;
  } 

  return (
    <MuiThemeProvider theme={muiTheme}>
      <MUIDataTable
        title={displayTitle || title || ""}
        data={data}
        columns={columns}
        options={options}
      />
    </MuiThemeProvider>
  );
}

ResourceDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  columnOrder: PropTypes.array,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  loading: PropTypes.bool,
  onSelect: PropTypes.func,
  onChangePrefs: PropTypes.func,
};

ResourceDataTable.defaultProps = {
  data: [],
  loading: false,
};
